import { initializeApp } from 'firebase/app'
import {
    GoogleAuthProvider,
    GithubAuthProvider,
    FacebookAuthProvider,
    OAuthProvider,
} from 'firebase/auth'

const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: "dicey-cc.firebaseapp.com",
    projectId: "dicey-cc",
    storageBucket: "dicey-cc.firebasestorage.app",
    messagingSenderId: "598847750489",
    appId: import.meta.env.VITE_FIREBASE_APP_ID
};

export const firebaseApp = initializeApp(firebaseConfig)

export const googleAuthProvider = new GoogleAuthProvider()

export const githubAuthProvider = new GithubAuthProvider()

export const facebookAuthProvider = new FacebookAuthProvider()

export const discordProvider = new OAuthProvider('oidc.discord')
